import React, { useContext, useMemo, useState } from "react";

import { RCADashboardContext } from "./RCADashboardContext";
import { IRCADashboardContextProps } from "./RCADashboardContextInterfaces";
import { UserContext } from "contexts/UserContext/UserContext";
import { useTableOperations } from "components/MainTable/hooks/useTableOperations";
import { IMyActionPlansFilters } from "pages/Corporate/RCA/RCADashboard/components/MyActionPlans/MyActionPlansInterfaces";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";

export const RCADashboardContextProvider: React.FC<IRCADashboardContextProps> = ({ children }) => {
    const { user_id } = useContext(UserContext);
    const {
        handleRequestSort: handleRequestSortActionPlans,
        handleChangeRowsPerPage: handleChangeRowsPerPageActionPlans,
        handleChangePage: handleChangePageActionPlans,
        order: orderActionPlans,
        orderBy: orderByActionPlans,
        page: pageActionPlans,
        rowsPerPage: rowsPerPageActionPlans,
    } = useTableOperations();
    const [userActionPlanFilters, setUserActionPlanFilters] = useState<IMyActionPlansFilters>({ showCompleted: false });

    const queryTableOperationFilters = useMemo(
        () => ({
            order: orderActionPlans,
            orderBy: orderByActionPlans,
            limit: rowsPerPageActionPlans,
            offset: pageActionPlans * rowsPerPageActionPlans,
        }),
        [orderActionPlans, orderByActionPlans, rowsPerPageActionPlans, pageActionPlans],
    );
    const {
        loading: loadingUserActionPlans,
        userActionPlans,
        apolloQueryError: userActionPlansError,
        refetch: refetchUserActionPlans,
        totalCount: totalCountActionPlans,
    } = ActionPlanEntity.GetAllUserActionPlans(queryTableOperationFilters, user_id!, userActionPlanFilters);

    const providerValue = {
        userActionPlans,
        loadingUserActionPlans,
        userActionPlansError,
        refetchUserActionPlans,
        userActionPlanFilters,
        setUserActionPlanFilters,
        orderActionPlans,
        orderByActionPlans,
        pageActionPlans,
        rowsPerPageActionPlans,
        handleRequestSortActionPlans,
        handleChangeRowsPerPageActionPlans,
        handleChangePageActionPlans,
        totalCountActionPlans,
    };

    return <RCADashboardContext.Provider value={providerValue}>{children}</RCADashboardContext.Provider>;
};
